// Toggle the profile menu when hovered
// Lock profile menu open when clicked

jQuery(function ($) {
	let loggedInBar  = $('.utility-bar .logged-in'),
        loggedInMenu = $('.utility-bar .logged-in .menu');
    
    if (loggedInBar.length && loggedInMenu.length) {
    	setUpProfileMenu($);
    }
});

function setUpProfileMenu($) {
	let body = $('body'),
		loggedInBar = $('.utility-bar .logged-in'),
        loggedInMenu = $('.utility-bar .logged-in .menu');
    
	
	loggedInBar.mouseenter( function() {
		if( $(this).hasClass('toggling')){return;}
		$(this).addClass('toggling');
		loggedInMenu.slideDown( 300, function() {
			loggedInBar.removeClass('toggling');
		});
	});

	loggedInBar.mouseleave( function() {
		if( loggedInMenu.hasClass('toggling')){return;}
		if ( ! body.hasClass('profile-menu-visible') ) {
			loggedInMenu.slideUp();
		}
	});

	loggedInBar.click( function() {
		if ( body.hasClass('profile-menu-visible') ) {
			hideProfileMenuSticky($);
		} else {
			showProfileMenuSticky($);
		}
	});
}

function showProfileMenuSticky($) {
	let body = $('body'),
        loggedInMenu = $('.utility-bar .logged-in .menu');
    
	
	loggedInMenu.slideDown();
    body.addClass('profile-menu-visible');
    // If the mobile menu is open, close it
	body.removeClass('mobile-menu-visible');
}

function hideProfileMenuSticky($) {
	let body = $('body'),
        loggedInMenu = $('.utility-bar .logged-in .menu');
    
	body.removeClass('profile-menu-visible');
	loggedInMenu.slideUp();
}

